"use strict";
const memo = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  function get(...args) {
    const key = JSON.stringify(args);
    if (cache[key] === void 0) cache[key] = fn(...args);
    return cache[key];
  }
  return get;
};

export { memo };
